import React, { useEffect, useState } from "react";
import CardLoading from "../../../../components/CardLoading";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";
import { numberWithCommas } from "../../../../utils";

function InitialBoqTable() {
  const url = "api/v2/flid/boq/fetch";
  const { loading, data, count, activeObjexpIsp } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjexpIsp: state.obj.activeObj["expressionIsp"],
    })
  );
  const { refetchKey } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Item",
      dataIndex: "fpbItemName",
      sorter: (a, b) => a.fpbItemName.localeCompare(b.fpbItemName),
    },
    {
      title: "QTY",
      dataIndex: "fpbQuantity",
      render:(item)=>{
        return(
          <div>{numberWithCommas(item)}</div>
        )
      },
      sorter: (a, b) => a.fpbQuantity - b.fpbQuantity,
    },
    {
      title: "@",
      dataIndex: "fpbItemPrice",
      render:(item)=>{
        return(
          <div>{numberWithCommas(item)}</div>
        )
      },
      sorter: (a, b) => a.fpbItemPrice - b.fpbItemPrice,
    },
    {
      title: "SubTotal",
      dataIndex: "fpbItemSubtotal",
      render:(item)=>{
        return(
          <div>{numberWithCommas(item)}</div>
        )
      },
      sorter: (a, b) => a.fpbItemSubtotal - b.fpbItemSubtotal,
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10); 
  async function fetchInitialBoq(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        fpbProjectBidId: activeObjexpIsp?.projectBidId, 
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 2) {
    fetchInitialBoq();
    }
  }, [refetchKey]);
  

  if (loading) return <CardLoading />;
  return (
    <Table
      rowSelection={false}
      className="mt-[1.31rem] w-full"
      scroll={{
        x: 'auto',
      }}
      rowKey={(record) => record?.custId}
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
       position: ["bottomRight"],
        current: pageIndex + 1,
        total: count,
        pageSize: pageSize,
        onChange: (page, size) => {
          setPageIndex(page - 1);
          setPageSize(size);
          fetchInitialBoq(page - 1, size);
        },
        showSizeChanger: false,
        hideOnSinglePage: true,
      }}
    />
  );
}

export default InitialBoqTable;
